import { render, staticRenderFns } from "./SidePanelHeader.vue?vue&type=template&id=9a96d862&"
import script from "./SidePanelHeader.vue?vue&type=script&lang=ts&"
export * from "./SidePanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SidePanelHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports